class ColorFilter {
  constructor() {
    this.init();
    this.bindEvents();
  }

  init() {
    this.filterProducts();
  }

  bindEvents() {
    window.addEventListener('popstate', () => {
      this.filterProducts();
    });

    document.addEventListener('DOMContentLoaded', () => {
      this.filterProducts();
    });

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          const hasProductCards = Array.from(mutation.addedNodes).some((node) => {
            return (
              node.nodeType === 1 &&
              (node.classList?.contains('collection-product-card') || node.querySelector?.('.collection-product-card'))
            );
          });

          if (hasProductCards) {
            this.filterProducts();
          }
        }
      });
    });

    const productContainer = document.querySelector('#product-grid, .collection-product-list, .products-grid');
    if (productContainer) {
      observer.observe(productContainer, {
        childList: true,
        subtree: true,
      });
    }
  }

  getColorFiltersFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const colorFilters = urlParams.getAll('filter.v.option.color');

    if (colorFilters.some((color) => color.toLowerCase() === 'other')) {
      return [];
    }

    return colorFilters.map((color) => this.normalizeFilterName(color));
  }

  getTagFiltersFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const tagFilters = urlParams.getAll('filter.v.m.filters.tags');

    return tagFilters.map((tag) => this.normalizeFilterName(tag));
  }

  getPriceFiltersFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const priceFilters = urlParams.getAll('filter.v.m.filters.price');

    return priceFilters.map((price) => decodeURIComponent(price));
  }

  normalizeFilterName(filterName) {
    return filterName
      .toLowerCase()
      .replace(/\+/g, ' ')
      .replace(/[^a-z0-9\s]/g, '')
      .replace(/\s+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  normalizePriceRange(priceRange) {
    let normalized = priceRange.toLowerCase().replace(/%24/g, '$').replace(/\+/g, ' ').trim();

    normalized = normalized
      .replace(/\$/g, '')
      .replace(/–/g, '-')
      .replace(/\s*-\s*/g, '-')
      .replace(/under\s*/g, 'under-')
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace(/-+/g, '-');

    return normalized;
  }

  normalizeColorName(colorName) {
    return this.normalizeFilterName(colorName);
  }

  checkColorMatch(dataVariantColor, urlFilters) {
    if (!dataVariantColor || urlFilters.length === 0) {
      return urlFilters.length === 0;
    }

    const normalizedDataColor = dataVariantColor.toLowerCase();

    return urlFilters.some((filterColor) => {
      let cleanedFilter = filterColor.replace(/^aluminum-/, '');

      if (normalizedDataColor === cleanedFilter) {
        return true;
      }

      if (!cleanedFilter.includes('-')) {
        const dataWords = normalizedDataColor.split('-');
        return dataWords.some((dataWord) => dataWord === cleanedFilter);
      }

      return false;
    });
  }

  checkTagMatch(dataVariantTags, urlTagFilters) {
    if (!dataVariantTags || urlTagFilters.length === 0) {
      return urlTagFilters.length === 0;
    }

    const cardTags = dataVariantTags.split(',').map((tag) => tag.trim().toLowerCase());

    return urlTagFilters.some((filterTag) => {
      return cardTags.some((cardTag) => {
        if (cardTag === filterTag) {
          return true;
        }
        return cardTag.includes(filterTag) || filterTag.includes(cardTag);
      });
    });
  }

  checkPriceMatch(dataVariantPrice, urlPriceFilters) {
    if (!dataVariantPrice || urlPriceFilters.length === 0) {
      return urlPriceFilters.length === 0;
    }
    const hasMatch = urlPriceFilters.some((filterPrice) => {
      const exactMatch = dataVariantPrice === filterPrice;

      return exactMatch;
    });

    return hasMatch;
  }

  filterProducts() {
    const colorFilters = this.getColorFiltersFromUrl();
    const tagFilters = this.getTagFiltersFromUrl();
    const priceFilters = this.getPriceFiltersFromUrl();
    const productCards = document.querySelectorAll('.collection-product-card[data-variant-color]');

    const uniquePrices = new Set();
    productCards.forEach((card) => {
      const price = card.getAttribute('data-variant-price');
      if (price) uniquePrices.add(price);
    });

    productCards.forEach((card) => {
      const dataVariantColor = card.getAttribute('data-variant-color');
      const dataVariantTags = card.getAttribute('data-variant-tags');
      const dataVariantPrice = card.getAttribute('data-variant-price');

      const colorMatch = this.checkColorMatch(dataVariantColor, colorFilters);
      const tagMatch = this.checkTagMatch(dataVariantTags, tagFilters);
      const priceMatch = this.checkPriceMatch(dataVariantPrice, priceFilters);

      const shouldShow = colorMatch && tagMatch && priceMatch;

      if (shouldShow) {
        card.classList.remove('hidden');
      } else {
        card.classList.add('hidden');
      }
    });

    this.updateResultsCount(productCards, colorFilters, tagFilters, priceFilters);
  }

  updateResultsCount(productCards, activeColorFilters, activeTagFilters, activePriceFilters) {
    const visibleCards = Array.from(productCards).filter((card) => !card.classList.contains('hidden'));
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ColorFilter();
  });
} else {
  new ColorFilter();
}
